import type { ReactElement, RefObject } from 'react'
import React, { useRef } from 'react'

import { useButton } from '@react-aria/button'
import { useFocusRing } from '@react-aria/focus'
import type { KeyboardEvent, PressEvent } from '@react-types/shared'
import { buttonIcon } from '@ui-kit/components/ButtonIcon/styles'

import type { WebProps } from './types'

const ButtonIcon = (props: WebProps): ReactElement => {
  const { isFocusVisible, focusProps } = useFocusRing()

  const ref = useRef<HTMLButtonElement | HTMLAnchorElement>(null)

  const className = buttonIcon({
    isFocusVisible,
  })
  const { buttonProps } = useButton(
    {
      elementType: props.href === undefined ? 'button' : 'a',
      onPress: (e: PressEvent) => (props.onPress ?? props.onClick)?.(e),
      onKeyDown: (e: KeyboardEvent) => props.onKeyDown?.(e),
      type: 'button',
      href: props.href,
      target: props.openInNewTab ? '_blank' : undefined,
    },
    ref as React.RefObject<Element>
  )

  const commonProps = {
    ...buttonProps,
    ...focusProps,
    title: props.title,
    children: props.icon,
    'data-testid': props.testID,
    className,
  }

  if (!props.href) {
    return <button ref={ref as RefObject<HTMLButtonElement>} {...commonProps} />
  }
  return <a ref={ref as RefObject<HTMLAnchorElement>} {...commonProps} />
}

export default ButtonIcon
